<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import GroupDetail from '../../../../../groups/components/GroupDetail.vue'
import { GroupID } from '../../../../../groups/models/group'

definePage({
    props: true,
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        featureFlags: 'groups',
    }
})

const {
  id,
} = defineProps<{
    id: GroupID
}>()
</script>

<template>
  <GroupDetail
    :id="id"
  />
</template>